
<template>
  <div class="screen-container">
    <header class="screen-header">
      <img src="../../public/static/img/yslogo.png" height="40%" alt="">
    </header>
    <div class="screen-sub-title">
          <div class="title2">国家中小企业公共服务示范平台 &nbsp;&nbsp;&nbsp; 国家级服务型制造示范平台</div>
    </div>
    <div class="screen-body">
      <section class="screen-left">
        <div id="left-top">
          <ele-left-top></ele-left-top>
        </div>
        <div id="left-middle">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <div>周访问趋势</div>
              </div>
            </div>
            <div class="box-body">
              <ele-left-middle></ele-left-middle>
            </div>
          </div>
        </div>
        <div id="left-bottom">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <div>热门应用模块</div>
              </div>
            </div>
            <div class="box-body">
              <ele-left-bottom></ele-left-bottom>
            </div>
          </div>
        </div>
      </section>
      <section class="screen-middle">
        <div id="middle-top" style="height: 14%">
          <div class="middle-num-ul">
            <div
              v-for="(item, index) in downApp"
              :key="index"
              class="middle-num-li"
              :class="'num-li' + index"
            >
              <div class="middle-num-li-name">{{ item.name }}</div>
              <div class="middle-num-li-info">
                <i class="middle-num-li-info-num">
                  {{ item.num }}
                </i>
                <span>{{ item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 55%; margin-top: -7%" id="middle-top2">
          <ele-middle-two></ele-middle-two>
        </div>
        <div id="middle-bottom">
          <ele-middle-bottom></ele-middle-bottom>
        </div>
      </section>
      <section class="screen-right">
        <div id="right-top">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <span></span>
                <div>行业产能分析</div>
                <span></span>
              </div>
            </div>
            <div class="box-body">
              <ele-right-top></ele-right-top>
            </div>
          </div>
        </div>
        <div id="right-middle">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <div>区域产能分析</div>
              </div>
            </div>
            <div class="box-body">
              <ele-right-middle></ele-right-middle>
            </div>
          </div>
        </div>
        <div id="right-bottom">
          <div class="box">
            <div class="box-head">
              <div class="box-title">
                <div>设备类型产能分析</div>
              </div>
            </div>
            <div class="box-body">
              <ele-right-bottom></ele-right-bottom>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import eleLeftTop from "@/components/ele-left-top.vue";
import eleLeftMiddle from "@/components/ele-left-middle.vue";
import eleLeftBottom from "@/components/ele-left-bottom.vue";
import eleMiddleTwo from "@/components/ele-middle-two.vue";
import eleMiddleBottom from "@/components/ele-middle-bottom.vue";
import eleRightTop from "@/components/ele-right-top.vue";
import eleRightMiddle from "@/components/ele-right-middle.vue";
import eleRightBottom from "@/components/ele-right-bottom.vue";

export default {
  components: {
    eleLeftTop,
    eleLeftMiddle,
    eleLeftBottom,
    eleMiddleTwo,
    eleMiddleBottom,
    eleRightTop,
    eleRightMiddle,
    eleRightBottom,
  },
  data() {
    return {
      downApp: [],
      banner: [],
      tableData: [],
    };
  },
  mounted() {},
  computed: {},
  created() {
    this.getBannerData();
    this.getTableData();
  },
  methods: {
    async getBannerData() {
      const res = await axios.get(this.$api.allCount);
      if (res.data) {
        let arr = ["人", "家", "台"];
        let i = 0;
        for (const key in res.data.data) {
          let param = {};
          param.name = key;
          param.num = res.data.data[key].toString();
          param.unit = arr[i];
          i++;
          this.downApp.push(param);
        }
      }
    },

    async getTableData() {
      const { data: ret } = await axios.get("/middle-bottom");
      this.tableData = ret.data;
    },
  },
};
</script>
<style>
.el-carousel__mask {
  background: none !important;
}
.el-image__inner {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style lang="less" scoped>
.gaizi {
  background: url(/static/img/gaizi@3x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 120% 2.925rem;
}

.bg2 {
  background: url(/static/img/gx@3x.png);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 11.75rem 2.25rem;
}

.box1 {
  width: 2.1875rem;
  height: 2.6875rem;
  background: url("/static/img/szb@3x.png");
  font-family: "TXZT";
  display: flex;
  align-items: center;
  justify-content: center;
}

#middle-bottom {
  table {
    color: #abb8c0;

    td {
      padding: 5px 7px;
    }

    thead {
      td {
        div {
          padding: 0.125rem;
        }
      }
    }

    tbody {
      td {
        font-size: 0.875rem;
      }
    }
  }
}

#middle-top {
  width: 100%;
  height: 100%;
  margin-top: 8px;
}

#middle-top2 {
  width: 94%;
  //   margin: 0 auto;
  background: url("/static/img/banner@3x.png");
  background-repeat: no-repeat;
  -o-background-size: cover;
  background-position: 53% 1%;
  background-size: 160%;
}

::v-deep .el-carousel {
  height: 100%;
  overflow: hidden;
  .el-carousel__item {
    display: flex !important;
    // align-items: center;
    justify-content: center;
  }
}

.box {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: rgba(83, 98, 255, 0.1);
  border: 2px solid rgba(255, 255, 255, 0.26);
  border-radius: 12px;

  .box-head {
    position: relative;

    .box-title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 10px 5px 10px;
      div {
        width: 11rem;
        height: 2.5rem;
        border: 2px solid #4668ec;
        box-shadow: 0 0 8px 0 rgba(128, 173, 255, 0.5),
          inset 0 0 20px 0 rgba(26, 242, 255, 0.1);
        border-radius: 8px;
        font-size: 1.1rem;
        font-weight: normal;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: italic;
      }
      span {
        width: 2rem;
        color: #0087f9;
        font-size: 0.875rem;
        align-self: end;
        margin-left: 0.625rem;
      }
    }
  }

  .box-body {
    flex: 1;
    background-color: rgba(7, 65, 122, 0.2);
  }
}

.box-line-1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-2 {
  position: absolute;
  top: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-top: 1px solid #44c4ff;
}

.box-line-3 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

.box-line-4 {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-bottom: 1px solid #44c4ff;
}

// 全屏样式的定义
.fullscreen {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
  z-index: 100;
}

.resize {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.screen-container {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  //   background-image: linear-gradient(0deg, #0c0a96 1%, #000474 100%);
  background: url("/static/img/eleScreenBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;
  color: #fff;
  box-sizing: border-box;

  .screen-header {
    margin: 0 auto;
    width: 100%;
    height: 110px;
    background: url("/static/img/gyys-head.png");
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    display: flex;
    align-items: center;

    .title {
      height: 110px;
      line-height: 110px;
      color: #44c4ff;
      font-size: 2.2rem;
      text-align: center;
      //   padding-top: 0.9375rem;
      font-weight: bold;
      letter-spacing: 3px;
    }

    .desc {
      text-align: center;
      color: #44c4ff;
      font-size: 1.25rem;
      padding-top: 0.625rem;
    }
  }
}

.screen-body {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 10px;

  .screen-left {
    height: 100%;
    width: 27.6%;

    #left-top {
      height: 28%;
      position: relative;
    }

    #left-middle {
      height: 28%;
      margin-top: 4%;
      position: relative;
    }

    #left-bottom {
      height: 28%;
      margin-top: 4%;
      position: relative;
    }
  }

  .screen-middle {
    height: 100%;
    width: 41.5%;
    margin-left: 1.6%;
    margin-right: 1.6%;

    #middle-top {
      width: 100%;
      height: 56%;
      position: relative;
    }

    #middle-bottom {
      margin-top: 1%;
      width: 100%;
      height: 23%;
      position: relative;
    }
  }

  .screen-right {
    height: 100%;
    width: 27.6%;

    #right-top {
      height: 28%;
      position: relative;
    }

    #right-middle {
      height: 28%;
      margin-top: 4%;
      position: relative;
    }

    #right-bottom {
      height: 28%;
      margin-top: 4%;
      position: relative;
    }
  }
}
.middle-num-ul {
  height: 100%;
  display: flex;
  justify-content: space-between;
  .middle-num-li {
    width: 18rem;
    height: 8rem;
    background-size: 100% auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 1rem 0 0 0;

    .middle-num-li-name {
      padding-left: 6.5rem;

      font-size: 1.7rem;
      font-family: "pangmen";
    }
    .middle-num-li-info {
      padding-left: 6.5rem;
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      margin-top: 1rem;
      i {
        font-size: 1.8rem;
        color: #ffcf00;
        margin: 0;
        padding: 0;
        font-weight: bold;
      }
      span {
        font-size: 1rem;
        padding: 0 0 0.2rem 6px;
      }
    }
  }
  .num-li0 {
    background: url("/static/img/elenum0.png") top left no-repeat;
  }
  .num-li1 {
    background: url("/static/img/elenum1.png") top left no-repeat;
  }
  .num-li2 {
    background: url("/static/img/elenum2.png") top left no-repeat;
  }
}
.screen-sub-title {
    position: absolute;
    width: 100vw;
    left: 0;
    top: 112px;
     .title2 {
        width: 100%;
      text-align: center;
      color: rgb(35, 255, 252);
      font-size: 1.2rem;
      font-family: TXZT;
    }
}

</style>
